import { Tab, Tabs } from "@mui/material";
import axios from "axios";
import * as React from "react";

import { TabPanel } from ".";
import { Config } from "../../config/config";
import { getGlobalVar, Helpers } from "../../utils/helpers";
import { PopupMessage } from "../../utils/message";
import { PlayerAchievement } from "./achievements/playerAchievements";
import { JobsLoading } from "./dailyJobs/jobsLoading";
import { PlayerDailyJobs } from "./dailyJobs/playerDailyJobs";
import { PlayerDailyGifts } from "./dailyJobs/playerDailyGifts";

interface Props {
    playerId: string;
    activeEnv: any;
    heroesConfig: any;
    playerData: any;
}

interface State {
    activeTab: string;
    loaded: boolean;
    haveError: boolean;
    data: any;
}

export class PlayerAchievementsGroup extends React.Component<Props, State> {

    constructor(props) {
        super(props);

        this.state = {
            activeTab: "daily_jobs",
            loaded: false,
            haveError: false,
            data: {},
        };
    }

    handleChange = (_event, newTab: string) => {
        this.setState({ activeTab: newTab });
    }

    componentDidMount() {
        this.fetchData();
    }

    refreshList = () => {
        this.setState({ loaded: false, haveError: false }, () => {
            this.fetchData();
        });
    }

    fetchData = async () => {
        try {
            const response = await axios.get(`${Config.getInstance.apiUrl}/api/user/${this.props.playerId}/achievements`, {
                headers: { Authorization: Helpers.getSessionId(), env: this.props.activeEnv },
            });

            this.setState({

                loaded: true,
                data: response.data.data,
            });
        } catch (error) {
            PopupMessage.error(`Something went wrong`);

            this.setState({
                loaded: true,
                haveError: true,
            });
        }
    }

    deleteJob = (type, id, jobType?: any) => {
        const tempData = { ...this.state.data };
        console.log('temp data === ', tempData)
        if (jobType === 'ruby') {
            tempData[type].dailyJobs = tempData[type].dailyJobs.filter(item => item.id !== id);
        } else {
            tempData[type].rubyBattleJobs = tempData[type].rubyBattleJobs.filter(item => item.id !== id);
        }

        this.setState({ data: tempData });
    }

    changeProgress = (e, type, id, jobType?: "ruby" | "ranked") => {
        const tempData = { ...this.state.data };
        // let job = tempData[type].find(item => item.id === id);
        let job: any = undefined;

        // if (!job) {
            switch (type) {
                case "achievements":
                    tempData[type].push({
                        id,
                        progress: 0,
                        claimed: false,
                        addedInPanel: true,
                    });
                    break;
                case "daily_jobs":
                    if (jobType === "ruby") {
                        job = tempData[type].rubyBattleJobs.find(item => item.id === id);
                    } else {
                        job = tempData[type].dailyJobs.find(item => item.id === id);
                    }
                    console.log('job ====== ', job);
                    break;
            default:
                job = tempData[type].find(item => item.id === id);
                break;
        }

        // }

        if (job) {
            job.progress = +e.target.value;
        }

        this.setState({ data: tempData });
    }

    render() {
        if (this.state.haveError) {
            return (
                <div className="loadingIndicator" style={{ fontSize: 18, cursor: "pointer" }} onClick={this.refreshList}>
                    Refresh
                </div>
            );
        }

        return <div>
            <Tabs
                value={this.state.activeTab}
                onChange={this.handleChange}
            >
                <Tab value="daily_jobs" label="Daily Challenges" {...Helpers.a11yProps("daily_jobs")} />
                <Tab value="daily_gifts" label="Daily Gifts" {...Helpers.a11yProps("daily_gifts")} />
                <Tab value="achievements" label="Achievements" {...Helpers.a11yProps("achievements")} />
            </Tabs>

            <TabPanel value={this.state.activeTab} index="daily_jobs" style={{ width: "100%" }}>
                {this.state.loaded ? <PlayerDailyJobs
                    {...this.props}
                    fetchData={this.fetchData}
                    data={this.state.data.daily_jobs || []}
                    changeProgress={this.changeProgress}
                    deleteJob={this.deleteJob}
                    config={getGlobalVar("DAILY_JOBS")}
                /> : <JobsLoading/>}
            </TabPanel>
            <TabPanel value={this.state.activeTab} index="daily_gifts" style={{ width: "100%" }}>
                {this.state.loaded ? <PlayerDailyGifts
                    {...this.props}
                    fetchData={this.fetchData}
                    data={this.state.data.daily_gifts || []}
                    config={getGlobalVar("DAILY_JOBS")}
                /> : <JobsLoading/>}
            </TabPanel>
            <TabPanel value={this.state.activeTab} index="achievements" style={{ width: "100%" }}>
                {this.state.loaded && <PlayerAchievement
                    {...this.props}
                    fetchData={this.fetchData}
                    data={this.state.data.achievements || []}
                    changeProgress={this.changeProgress}
                    deleteJob={this.deleteJob}
                />}
            </TabPanel>
        </div>;
    }

}
